import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import styles from '../index.styl';
import {
  canEditNotJoinedPatient,
  canEditPatient,
  targetUserSelector,
} from '../../../redux/context/selectors';
import {
  selectMedicationAllergies,
  selectHealthConditions,
} from '../../../redux/data/selectors';
import { actions } from '../../../redux/profiles/edit-patient';
import { actions as editPatientByProviderActions } from '../../../redux/profiles/edit-patient-by-provider';
import { actions as preferredPharmacyActions } from '../../../redux/healthboard/patientPortal/set-preferred-pharmacy-req';

const mapStateToProps = state => ({
  profile: targetUserSelector(state),
  canEdit: canEditPatient(state),
  canEditPatient: canEditNotJoinedPatient(state),
  medicationAllergiesList: selectMedicationAllergies(state),
  healthConditionsList: selectHealthConditions(state),
});

const mapDispatchToProps = {
  savePatient: actions.send,
  savePatientByProvider: editPatientByProviderActions.send,
  savePreferredPharmacy: preferredPharmacyActions.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/PatientInfo/enhance.js